export const createTitle = (value: string): string => {
  if (!value.includes('-') && !value.includes('_')) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  return value
    .split(/[-_]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
